import "../styles/FlipCard.css"; // We'll define styles here

const ErrorPage = () => {



return(
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <div className="p-8 bg-white rounded-2xl shadow-xl w-80">
        <h1 className="text-2xl font-bold mb-4 text-center">Bem Vindo! </h1>Efetue seu login para continuar</div> </div>
);
}

export default ErrorPage;
